module.exports = __webpack_public_path__ + "img/photos/01.jpg";